import { Box, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Tooltip, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from "react";
import DatePicker from 'react-datepicker';
import { FaBarcode, FaMapMarkerAlt, FaMobileAlt, FaMoneyBillWave, FaPhone, FaRegCalendarAlt, FaShieldAlt, FaStoreAlt, FaTags, FaUser } from 'react-icons/fa';
import { FaFilePdf } from "react-icons/fa6";
import { ColorRing } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ApiCall } from './CustomHooks';
import { CommonApiData, base64ToBlob, handleDownload, handleShowFile } from './EnvConfig';
import { InputBox } from './InputBox';
export const Table = (
    {
        handleEdit,
        filterData,
        handleApprove,
        handleReject,
        handleGenerateBill,
        handleView,
        handleSettle,
        handleAccept,
        OtherExport = false,
        handlePrint,
        handlePrint1,
        handlePrintWithLogo,
        handlePrintWithoutLogo,
        handleDownloadLogo,
        handleDeleteLogo,
        matchingkey,
        matchingkey2 = '',
        ClickOnLink,
        handleDetail,
        handleCheck,
        handleCheckAll,
        checkAll,
        showCheckBox,
        handleExport,
        PageName,
        loading = false,
        Filter = true,
        handleChange1,
        currentPageNo,
        setFilterData,
        handleSorting,
        sortConfig,
        handleDelete,
        handleFilter,
        AdvancedFilter = true,
        tableData,
        children,
        onlyFilterPage = false,
        checkUnit = false,
        showLink = false,
        isEditTable = false
    }) => {
    const commonData = CommonApiData();
    const unitCode = useSelector((state) => state.header.unitCode);
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const inputrefs = useRef([]);
    const AdvanceSearchModelcloseButtonRef = useRef(null);
    const AdvanceSearchModelInputRef = useRef([]);
    const [ModalData, setModalData] = useState([]);
    const [MainData, setMainData] = useState(tableData?.Data ? tableData?.Data : []);
    const [ModalTitleKey, setModalTitleKey] = useState([]);
    const [ModalHeaderKey, setModalHaderKey] = useState([]);
    const [AdvanceModelCleared, setAdvanceModelCleared] = useState(false);

    const ShowEyeRecords = (data, key) => {
        setModalData(data)
        setModalTitleKey(key)
        setModalHaderKey(Object?.keys(data[0]))
    };

    //const finalHeaderKeys = tableData?.HeadersKey?.filter(
    //    (key, index) => {
    //        return !tableData?.HideColumns.find((column) => key === column)
    //    }
    //);
    const FinalHeaderKeys = tableData?.HeadersKey?.length > 0
        ? tableData?.HeadersKey?.filter((key) => !tableData?.HideColumns?.includes(key))
        : Array.from(
            new Set(
                tableData?.Data?.flatMap((data) => Object.keys(data))
                    .filter((columnName) => !tableData?.HideColumns?.includes(columnName))
            )
        );

    //const finalHeadersValue = tableData?.HeadersValue?.filter(
    //    (key) => {
    //        return !tableData?.HideColumns.find((column) => key === column)
    //    }
    //);

    const FinalHeadersValue = (tableData?.HeadersKey?.length > 0 && tableData?.HeadersValue?.length > 0)
        ? tableData.HeadersValue.filter((key) => !tableData?.HideColumns?.includes(key))
        : Array.from(
            new Set(
                tableData.Data?.flatMap((data) => Object.keys(data))
                    .filter((columnName) => !tableData?.HideColumns?.includes(columnName))
            )
        );

    const [ColoredRow, setColoredRow] = useState('');
    // only work when id is present
    //const handleHighlight = (id) => {
    //    setColoredRow(id)
    //};

    //work when both id and index present
    const handleHighlight = (id, index) => {
        const highlightedId = id !== undefined ? id : index;
        setColoredRow(highlightedId);
    };
    /**Local Handle Shorting  in Table please don't Remove this code*/
    //const [order, setOrder] = useState('ASC');
    //const handleSorting = (col) => {
    //    if (order === 'ASC') {
    //        const sorted = [...tableData.Data].sort((a, b) =>
    //            (a[col.replaceAll(' ', '')]).toLowerCase() > (b[col.replaceAll(' ', '')]).toLowerCase() ? 1 : -1
    //        )
    //        setMainData(sorted)
    //        setOrder('DESC')
    //    }
    //    if (order === 'DESC') {
    //        const sorted = [...tableData.Data].sort((a, b) =>
    //            (a[col.replaceAll(' ', '')]).toLowerCase() < (b[col.replaceAll(' ', '')]).toLowerCase() ? 1 : -1
    //        )
    //        setMainData(sorted)
    //        setOrder('ASC')
    //    }
    //}
    /**Local Handle Shorting  in Table please don't Remove this code*/

    let RequestData = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "PageName": PageName
    };
    const [serchingData, setSerchingData] = useState([]);
    const [advanceSearchingData, setAdvanceSearchingData] = useState([]);

    const handleResetAdvanceFilter = () => {
        let updatedDataList = advanceSearchingData?.map((item, index) => ({
            ...item,
            Value: ''
        }));
        setAdvanceSearchingData(updatedDataList);
        setFilterData({ ...filterData, AdvanceFilter: [] });
        setAdvanceModelCleared(true)
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (advanceSearchingData?.length > index + 1) {
                AdvanceSearchModelInputRef.current[index + 1].focus();
            } else {
                AdvanceSearchModelInputRef.current['btnAdvSubmit'].focus();
            }
        }
    };

    const serching = async () => {
        if (Filter) {
            let data = await ApiCall('/api/AutoComplete/GetSearchingColumn', RequestData)
            setSerchingData(data.getSearchingList)
            setAdvanceSearchingData(data.advanceDataList)
            setFilterData({ ...filterData, SearchFieldValue: data.getSearchingList[0].valuePart })
        }
    };

    //---------- handle Show file --------//
    const ShowFileHandler = async (value) => {
        handleShowFile({ ...Data, FormName: PageName, ID: value.ID, CallType: value.CallType })
    }

    //-------- handle Download file ---------//
    const DownloadFileHandler = async (value) => {
        handleDownload({ ...Data, FormName: PageName, ID: value.ID, CallType: value.CallType })
    };

    const handleDownloadExcelFile = async (value) => {
        try {
            let excelResult = await ApiCall('/api/Image/GetImage', { ...Data, FormName: 'CustomerMaster', ID: value.ID, CallType: value.CallType });

            if (excelResult?.data?.fileBase64) {
                const base64String = excelResult.data.fileBase64.split(',')[1].trim();
                const contentType = excelResult?.data?.contentType || 'application/octet-stream';
                const dataURI = `data:${contentType};base64,${base64String}`;
                const link = document.createElement("a");
                link.href = dataURI;
                link.download = "data.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error("Base64 string is empty or undefined.");
            }
        } catch (error) {
            console.error("Error while handling download:", error);
        }
    };

    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize))) ? Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize))) : 1;


    // Show Edit Modal
    const draggingCard = useRef();

    const [showEditTableModal, setShowEditTableModal] = useState(false);
    const [searchingEditableHeader, setSearchingEditableHeader] = useState('');
    const [finalHeadersValue, setFinalHeadersValue] = useState([]);
    const [finalHeadersKeys, setFinalHeadersKeys] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(false);
    const [selectedHeader, setSelectedHeader] = useState([]);
    const fixedHeader = ["city"]
    const handleCloseEditTableModal = () => {
        setShowEditTableModal(false)
    }

    const handleCheckBox = (ele, e, index) => {

        setHoveredIndex(null)
        const tempData = {
            headerName: ele,
            sequance: index,
            isFixed: fixedHeader?.includes(ele.replace(" ", "").toLowerCase())
        };
        if (e.target.checked) {
            setSelectedHeader([...selectedHeader, tempData]);
        } else if (selectedHeader.length > 1) {
            const temp = [...selectedHeader];
            const filterdata = temp.filter(item => item.headerName !== ele)
            setSelectedHeader(filterdata);
        }
    }

    const handleSaveEditTableData = () => {
        const updatedKeys = selectedHeader.map(ele => ele.headerName)
        setFinalHeadersValue(updatedKeys);
        setFinalHeadersKeys(updatedKeys);
        handleCloseEditTableModal();
    }


    const handleDragStart = (event, index) => {
        draggingCard.current = index;
    };

    const handleDragEnter = (event, index) => {
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(draggingCard.current, 1)[0];
        updatedHeader.splice(index, 0, moverItem);
        setSelectedHeader(updatedHeader);
        draggingCard.current = index;
    }

    const handleMoveToTop = (index) => {
        if (index === 0) return;
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(index, 1)[0];
        updatedHeader.splice(0, 0, moverItem,);
        setSelectedHeader(updatedHeader);
    };

    const handleMoveToBottom = (index) => {
        if (index === selectedHeader.length - 1) return;
        const updatedHeader = [...selectedHeader];
        const moverItem = updatedHeader.splice(index, 1)[0];
        updatedHeader.splice(selectedHeader.length - 1, updatedHeader.length, moverItem);
        setSelectedHeader(updatedHeader);
    };

    const handleRemoveShowHeader = (ele) => {
        if (selectedHeader.length > 1) {
            const temp = [...selectedHeader];
            const filterdata = temp.filter(item => item.headerName !== ele)
            setSelectedHeader(filterdata);
        }
    }

    const resetShowHeaderValues = () => {
        if (finalHeadersValue) {
            setSelectedHeader(FinalHeadersValue.map((ele, i) => ({
                headerName: ele,
                sequance: i,
                isFixed: fixedHeader?.includes(ele.replace(" ", "").toLowerCase())
            })));
        }
    }

    useEffect(() => {
        resetShowHeaderValues();
    }, [tableData.HeadersValue]);

    useEffect(() => {
        serching();
    }, []);

    useEffect(() => {
        setMainData(tableData?.Data)
    }, [tableData]);


    useEffect(() => {
        setFinalHeadersKeys(FinalHeaderKeys)
        setFinalHeadersValue(FinalHeadersValue)
    }, [tableData.Data]);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        if (AdvanceModelCleared) {
            handleFilter();
            setAdvanceModelCleared(false)
        }
    }, [AdvanceModelCleared]);

    return (
        <div>  {
            tableData ? (
                <div className='main-card card border-0 mb-0' >
                    {/* Filter and Advance Filter Icon and paging*/}
                    <div className='card-header mb-1'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-md-4'>
                                <h6 className='m-0 d-flex gap-2'>
                                    <span>{`${tableData?.TotalRecord !== undefined ? 'Total Records : ' + tableData?.TotalRecord : (tableData?.Data?.length ? 'Total Records : ' + tableData?.Data?.length : 'No Record Found')}`}</span>
                                    <span>{showCheckBox && tableData?.Data?.filter(d => d.checkStatus).length > 0 ? `, Selected: ${tableData?.Data?.filter(d => d.checkStatus).length}` : ''}</span>
                                </h6>
                            </div>
                            {Filter ?
                                //Normal Filter Inputs
                                <div className='col-md-8 col-lg-6 d-flex flex-row filters'>
                                    <select
                                        value={filterData?.SearchFieldValue}
                                        onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}
                                        className="form-select me-2"
                                        aria-label="Default select example">
                                        {Array.isArray(serchingData) ? (
                                            serchingData?.map((list, i) => (
                                                <option key={`filterList${i}`} value={list?.valuePart}> {list?.textPart}</option>
                                            ))
                                        ) : (<></>)}
                                    </select>
                                    <select className="form-select me-2" aria-label="Condition"
                                        value={filterData?.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}
                                    >
                                        <option value="1">Exactly</option>
                                        <option value="2">Contains</option>
                                        <option value="3">Start With</option>
                                    </select>
                                    <input type="text"
                                        className="form-control search"
                                        placeholder="Search"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleFilter()
                                            };
                                        }}
                                        value={filterData?.SearchText}
                                        onChange={(e) => setFilterData({ ...filterData, SearchText: e.target.value })}
                                    />
                                    {/*Normal Filter Button*/}
                                    <button onClick={handleFilter} className="btn search-btn me-2"><i className="fa-solid fa-magnifying-glass"></i></button>
                                    {/*Advance Filter Button*/}
                                    {
                                        advanceSearchingData && advanceSearchingData?.length !== 0 && (<button className='btn advance-search-btn' data-bs-toggle="modal" data-bs-target="#AdvanceSearchModal" >
                                            <i className="fa-solid fa-filter"></i>
                                        </button>)
                                    }
                                    {/*Page Size DropDown*/}
                                    {
                                        filterData?.PageSize ?
                                            <>
                                                <select className="form-select me-2" aria-label="PageSize" style={{ width: "110px" }}
                                                    value={filterData?.PageSize ? filterData?.PageSize : "10"} onChange={(e) => {
                                                        setFilterData({ ...filterData, PageSize: e.target.value })
                                                        setAdvanceModelCleared(true)
                                                    }}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="200">200</option>
                                                    <option value="500">500</option>
                                                </select>
                                                {isEditTable &&
                                                    <span className='d-flex justify-content-between gap-2 align-items-center'
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setShowEditTableModal(true)}>
                                                        <i className="fa fa-columns arrow" title={'Edit Columns'} aria-hidden="true" ></i>
                                                    </span>
                                                }
                                            </>
                                            : <></>
                                    }

                                </div>
                                :
                                OtherExport ?
                                    <div className='col-md-8 col-lg-6 flex-row filters'>
                                        <button type="button" className="btn btn-rounded mb-0 btn-warning" style={{ float: 'right' }} name='tblExp'
                                            onClick={handleExport}
                                        >< span className=" text-warning me-2"><i className="fa fa-download text-white color-success"></i>
                                            </span>Export
                                        </button>
                                    </div>
                                    : <> {onlyFilterPage && <>
                                        {
                                            filterData?.PageSize &&
                                            <>
                                                <div className='d-flex  align-items-center' style={{ minWidth: '100px', maxWidth: '150px' }}>
                                                    <select className="form-select me-2" aria-label="PageSize" style={{ width: "110px" }}
                                                        value={filterData?.PageSize ? filterData?.PageSize : "10"} onChange={(e) => {
                                                            setFilterData({ ...filterData, PageSize: e.target.value })
                                                            setAdvanceModelCleared(true)
                                                        }}
                                                    >
                                                        <option value="10">10</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="200">200</option>
                                                        <option value="500">500</option>
                                                    </select>
                                                    {isEditTable &&
                                                        <span className='d-flex justify-content-between gap-2 align-items-center'
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setShowEditTableModal(true)}>
                                                            <i className="fa fa-columns arrow" title={'Edit Columns'} aria-hidden="true" ></i>
                                                        </span>
                                                    }
                                                </div>
                                            </>}
                                    </>}</>
                            }

                        </div>
                    </div>

                    {/* Loader in table*/}
                    {loading ?
                        <><center>
                            <ColorRing
                                visible={true}
                                height="80"
                                width="80"
                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                            />
                        </center></>
                        :
                        /* Table Data*/
                        <div className='card-body'>
                            <div className="table-responsive main-table">
                                <table className="table table-bordered table-striped mb-0">
                                    <thead className='sticky-table-header'>
                                        <tr className='light-bg'>
                                            {(tableData?.Data && tableData?.Data?.filter(record => record.Actions).length > 0) || (tableData?.Actions && tableData?.Actions.length > 0 && tableData?.Actions?.includes('Checkbox') === false) ?
                                                <th>Action</th> :
                                                <></>
                                            }
                                            {tableData?.Data && tableData?.Data[0]?.hasOwnProperty("Checkbox") && PageName !== 'ManifestWithPackage'
                                                ?
                                                <th style={{ width: showCheckBox ? '20px' : '10px' }} key="thActions">
                                                    <input
                                                        className="form-check-input mt-0"
                                                        type="checkbox"
                                                        checked={checkAll}
                                                        onChange={(e) => handleCheckAll(e.target.checked)}
                                                    />
                                                </th> : <></>
                                            }
                                            {finalHeadersKeys?.map((th, headIndex) => (
                                                <th key={`th${headIndex || 0}`} style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        handleSorting ?
                                                            handleSorting(finalHeadersValue[headIndex]) : ''}
                                                >
                                                    {th}
                                                    {
                                                        (sortConfig?.SortColumn !== null
                                                            && sortConfig?.SortOrder !== null
                                                            && sortConfig?.SortColumn === finalHeadersValue[headIndex]) ?
                                                            (
                                                                <>
                                                                    <i className="fa fa-arrow-up ms-2" style={{ color: sortConfig?.SortOrder !== 'DESC' ? '#d4d4d4' : 'red' }} ></i>
                                                                    <i className="fa fa-arrow-down" style={{ color: sortConfig?.SortOrder !== 'ASC' ? '#d4d4d4' : 'red' }}  ></i>
                                                                </>
                                                            )
                                                            : (
                                                                <>
                                                                    <i className="fa fa-arrow-up ms-2" style={{ color: '#d4d4d4' }}></i>
                                                                    <i className="fa fa-arrow-down" style={{ color: '#d4d4d4' }}  ></i>
                                                                </>
                                                            )
                                                    }

                                                </th> || <></>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MainData?.map((item, bodyIndex) => (
                                            <tr className={`TableTrhover ${ColoredRow === bodyIndex || item.Edit === ColoredRow ? 'activeTd' : ''}`} key={`row${bodyIndex}`} onClick={() => handleHighlight(item.Edit, bodyIndex)} style={{ backgroundColor: showCheckBox && item.Color }} >
                                                {(tableData?.Data && tableData?.Data?.filter(record => record.Actions).length > 0) || (tableData?.Actions && tableData?.Actions.length > 0) ? (
                                                    PageName !== 'ManifestWithPackage' && <td key={`tdAction${bodyIndex}`} style={{ textAlign: 'center', width: '0rem' }}>
                                                        {item.Actions !== undefined ?
                                                            item.Actions?.split(',').map((btn, index) => (
                                                                <span key={index} className='ms-2'>
                                                                    {(btn === 'Edit' && item?.Edit?.trim() !== "") ? <i className="fa-regular fa-pen-to-square text-success me-2" key={`row${bodyIndex}edit${index}`} title='Edit' onClick={() => handleEdit(item.Edit, item)} /> : (<></>)}
                                                                    {(btn === 'Del' && item?.Del?.trim() !== "") ? <i className="fa-regular fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}del${index}`} onClick={() => handleDelete(item.Del, item)} /> : (<></>)}
                                                                    {(btn === 'Print' && item?.Print?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint(item.Print)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'Print2' && item?.Print2?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint1(item.Print)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'Print3' && item?.Print3?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint(item.Print3)} style={{ cursor: 'pointer' }} /> : (<></>)}

                                                                    {(btn === 'Delete' && item?.Delete?.trim() !== "") ? <i className="fa-regular fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}print${index}`} onClick={() => handleDeleteLogo(item.Delete)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'PrintWithLogo' && item?.PrintWithLogo?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print With Logo' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintWithLogo(item.PrintWithLogo)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'PrintWithOutLogo' && item?.PrintWithOutLogo?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print Without Logo' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintWithoutLogo(item.PrintWithOutLogo)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'Download' && item?.Download?.trim() !== "") ? <i className="fa fa-download text-primary me-2" title='Download' key={`row${bodyIndex}print${index}`} onClick={() => handleDownloadLogo(item.Download)} style={{ cursor: 'pointer' }} /> : (<></>)}

                                                                    {(btn === 'Detail' && item?.Detail?.trim() !== "") ? <i className="fa fa-info-circle text-info me-2" title='Detail' role="button" key={`row${bodyIndex}Detail${index}`} onClick={() => handleDetail(item.Detail)} /> : (<></>)}
                                                                    {btn === 'Checkbox' ?
                                                                        <input
                                                                            className="form-check-input mt-0"
                                                                            type="checkbox"
                                                                            checked={item.checkStatus}
                                                                            id={item.Checkbox}
                                                                            onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                                        />
                                                                        : (<></>)}
                                                                    {btn === 'Approve' ?
                                                                        <i className="fa-solid fa-circle-check text-success" style={{ cursor: 'pointer', fontSize: '13px' }} title={'Approve'} onClick={() => handleApprove(item.Approve, item)} ></i>
                                                                        : (<></>)}
                                                                    {btn === 'Reject' ?
                                                                        (item.Reject !== "0" &&
                                                                            <i class="fa-solid fa-square-xmark text-danger" title='Reject' style={{ cursor: 'pointer', fontSize: '13px' }} onClick={() => handleReject(item.Reject)}></i>)
                                                                        : (<></>)}
                                                                    {btn === 'GenerateBill' ?
                                                                        <button type="button"
                                                                            onClick={() => handleGenerateBill(item.GenerateBill, item.Customer, item.Mode, item.PayMode)}
                                                                            className="ApproveBtn btn btn-rounded btn-primary">Generate Bill</button>
                                                                        : (<></>)}
                                                                    {btn === 'ViewCN' ?
                                                                        <button type="button"
                                                                            onClick={() => handleView(item.ViewCN)}
                                                                            className="ApproveBtn btn btn-rounded btn-warning"> <i class="fa fa-eye pe-1" aria-hidden="true"></i>View CN</button>
                                                                        : (<></>)}
                                                                    {btn === 'Settle' ?
                                                                        <button type="button"
                                                                            onClick={() => handleSettle(item.Settle)}
                                                                            className="ApproveBtn btn btn-rounded btn-warning">
                                                                            <span className=" text-white me-1">
                                                                                <i className="fa">&#xf0c7;</i>
                                                                            </span>Settle</button>
                                                                        : (<></>)}
                                                                    {btn === 'Accept' ?
                                                                        <button type="button"
                                                                            onClick={() => handleAccept(item.Accept)}
                                                                            className="ApproveBtn btn btn-rounded" style={{ background: '#049b2b', color: 'white' }}>
                                                                            <span className=" text-white me-1">
                                                                                <i class="fa-solid fa-circle-check"></i>
                                                                            </span>Accept</button>
                                                                        : (<></>)}
                                                                </span>
                                                            )) : tableData?.Actions?.map((btn, index) => (
                                                                <span key={index}>
                                                                    {(btn === 'Edit') ? <i className="fa-regular fa-pen-to-square text-success me-2" key={`row${bodyIndex}edit${index}`} title='Edit' onClick={() => handleEdit(item.Edit)} /> : (<></>)}
                                                                    {btn === 'Del' ? <i className="fa-regular fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}del${index}`} onClick={() => handleDelete(item.Del)} /> : (<></>)}
                                                                    {btn === 'Print' ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint(item.Print)} /> : (<></>)}
                                                                    {(btn === 'Print2' && item?.Print2?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint(item.Print2)} /> : (<></>)}
                                                                    {(btn === 'Print3' && item?.Print3?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print' key={`row${bodyIndex}print${index}`} onClick={() => handlePrint(item.Print3)} /> : (<></>)}

                                                                    {(btn === 'Delete' && item?.Delete?.trim() !== "") ? <i className="fa-regular fa-trash-can text-danger me-2" title='Delete' key={`row${bodyIndex}print${index}`} onClick={() => handleDeleteLogo(item.Delete)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'PrintWithLogo' && item?.PrintWithLogo?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print With Logo' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintWithLogo(item.PrintWithLogo)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'PrintWithOutLogo' && item?.PrintWithOutLogo?.trim() !== "") ? <i className="fa fa-print text-primary me-2" title='Print Without Logo' key={`row${bodyIndex}print${index}`} onClick={() => handlePrintWithoutLogo(item.PrintWithOutLogo)} style={{ cursor: 'pointer' }} /> : (<></>)}
                                                                    {(btn === 'Download' && item?.Download?.trim() !== "") ? <i className="fa fa-download text-primary me-2" title='Download' key={`row${bodyIndex}print${index}`} onClick={() => handleDownloadLogo(item.Download)} style={{ cursor: 'pointer' }} /> : (<></>)}

                                                                    {btn === 'Detail' ? <i className="fa fa-info-circle text-info me-2" title='Detail' role="button" key={`row${bodyIndex}Detail${index}`} onClick={() => handleDetail(item.Detail)} /> : (<></>)}
                                                                    {btn === 'Checkbox' ?
                                                                        <input
                                                                            className="form-check-input mt-0"
                                                                            type="checkbox"
                                                                            checked={item.checkStatus}
                                                                            id={item.Checkbox}
                                                                            onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                                        />
                                                                        : (<></>)}
                                                                    {btn === 'Approve' ?
                                                                        <i class="fa-solid fa-circle-check text-success" style={{ cursor: 'pointer', fontSize: '13px' }} title={'Approve'} onClick={() => handleApprove(item.Approve, item)} ></i>
                                                                        : (<></>)}
                                                                    {btn === 'Reject' ?
                                                                        (item.Reject !== "0" &&
                                                                            <i class="fa-solid fa-square-xmark text-danger" title='Reject' style={{ cursor: 'pointer', fontSize: '13px' }} onClick={() => handleReject(item.Reject)}></i>)
                                                                        : (<></>)}
                                                                    {btn === 'GenerateBill' ?
                                                                        <button type="button"
                                                                            onClick={() => handleGenerateBill(item.GenerateBill, item.Customer, item.Mode, item.PayMode)}
                                                                            className="ApproveBtn btn btn-rounded btn-primary">
                                                                            <span className=" text-white me-1">
                                                                                <i className="fa">&#xf0c7;</i>
                                                                            </span>Generate Bill</button>
                                                                        : (<></>)}
                                                                    {btn === 'ViewCN' ?
                                                                        <button type="button"
                                                                            onClick={() => handleView(item.ViewCN)}
                                                                            className="ApproveBtn btn btn-rounded btn-warning">
                                                                            <span className=" text-white me-1">
                                                                                <i className="fa">&#xf0c7;</i>
                                                                            </span>View CN</button>
                                                                        : (<></>)}
                                                                    {btn === 'Settle' ?
                                                                        <button type="button"
                                                                            onClick={() => handleSettle(item.Settle)}
                                                                            className="ApproveBtn btn btn-rounded btn-warning">
                                                                            <span className=" text-white me-1">
                                                                                <i className="fa">&#xf0c7;</i>
                                                                            </span>Settle</button>
                                                                        : (<></>)}
                                                                    {btn === 'Accept' ?
                                                                        <button type="button"
                                                                            onClick={() => handleAccept(item.Accept)}
                                                                            className="ApproveBtn btn btn-rounded" style={{ background: '#049b2b', color: 'white' }}>
                                                                            <span className=" text-white me-1">
                                                                                <i class="fa-solid fa-circle-check"></i>
                                                                            </span>Accept</button>
                                                                        : (<></>)}
                                                                </span>
                                                            ))
                                                        }
                                                    </td>
                                                ) : (
                                                    <></>
                                                )}
                                                {
                                                    tableData?.Data && tableData?.Data[0]?.hasOwnProperty("Checkbox") && tableData?.Actions.includes('Checkbox') === false && PageName !== 'ManifestWithPackage' ?
                                                        <td className='text-center'>
                                                            <input
                                                                className="form-check-input mt-0"
                                                                type="checkbox"
                                                                checked={item.checkStatus}
                                                                id={item.Checkbox}
                                                                onChange={(e) => handleCheck(e.target.checked, item.Checkbox, bodyIndex)}
                                                            />
                                                        </td> : <></>
                                                }

                                                {finalHeadersValue?.map((key, tdIndex) => (

                                                    (typeof (item[key]) === 'object') ? (
                                                        Array?.isArray(item[key]) ?
                                                            (item[key].length > 0 ?
                                                                <td key={`key${tdIndex}`}>
                                                                    <i className="fa fa-eye"
                                                                        data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                                        style={{ cursor: 'pointer', color: '#5a8dee' }}
                                                                        onClick={() => ShowEyeRecords(item[key], key)}
                                                                    />
                                                                </td> : <td key={`key${tdIndex}`}></td>) : (
                                                                typeof (item[key]) === 'object' && item[key]?.FileType === 'pdf' ?
                                                                    <td key={`key${tdIndex}`} className='d-flex gap-1'>
                                                                        <FaFilePdf title='open PDF'
                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                                            onClick={() => { ShowFileHandler(item[key]) }}
                                                                        />
                                                                        <i className='fa fa-download'
                                                                            title='Download'
                                                                            onClick={() => { DownloadFileHandler(item[key]) }}
                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }} />
                                                                    </td> :
                                                                    typeof (item[key]) === 'object' && item[key]?.FileType === 'xlsx' ?
                                                                        <td key={`key${tdIndex}`} onClick={() => { handleDownloadExcelFile(item[key]) }}>
                                                                            <FaFilePdf title='Download Excel' style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }} />
                                                                        </td> :

                                                                        typeof (item[key]) === 'object' && !item[key]?.FileType ? (<td key={`key${tdIndex}`}></td>) :
                                                                            (<td key={`key${tdIndex}`} >
                                                                                <i className="fa fa-image me-2"
                                                                                    title='show Image'
                                                                                    onClick={() => { ShowFileHandler(item[key]) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                />
                                                                                <i className='fa fa-download'
                                                                                    title='Download'
                                                                                    onClick={() => { DownloadFileHandler(item[key]) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }} />
                                                                            </td>
                                                                            )
                                                            )
                                                    ) :
                                                        matchingkey !== key ?

                                                            <td key={`key${tdIndex}`} style={{ color: ColoredRow === bodyIndex || item.Edit === ColoredRow ? '#000' : '' }}>{item[key]}</td>
                                                            //: item?.IsClosed?.toUpperCase() === 'TRUE' ? <td key={`key${tdIndex}`} style={{ color: ColoredRow === bodyIndex || item.Edit === ColoredRow ? '#000' : '' }}>{item[key]}</td>
                                                            : showLink ? <td key={`key${tdIndex}`} title='Link' style={{ color: ColoredRow === bodyIndex || item.Edit === ColoredRow ? '#000' : '' }}>
                                                                {unitCode === item.Unit && checkUnit ? <Link to='' className='matching_key' style={{ textDecoration: "none", color: 'var(--text)', textShadow: ".7px .3px #5a8dee", fontSize: '13px' }} onClick={() => ClickOnLink(item[key])} >{item[key]}</Link> : item[key]}
                                                            </td> :
                                                                <td key={`key${tdIndex}`} title='Link' style={{ color: ColoredRow === bodyIndex || item.Edit === ColoredRow ? '#000' : '' }}>
                                                                    <span className='matching_key' style={{ textDecoration: "none", color: 'var(--text)', textShadow: ".7px .3px #5a8dee", fontSize: '13px', cursor: 'pointer' }} onClick={() => ClickOnLink(item[key], item[matchingkey2])} >{item[key]}</span>
                                                                </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {countNo > 1 ?
                                < Pagination className='pt-2' count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange1} shape="rounded" />
                                : ''}
                        </div>
                    }

                    {/*  Advance Filter Modal Form*/}
                    {AdvancedFilter ?
                        <div className="modal fade" id="AdvanceSearchModal" tabIndex="-1" role="dialog" aria-labelledby="AdvanceSearchModalLabel" aria-hidden="true">
                            <div className='modal-dialog modal-lg modal-dialog-centered' style={{ width: '500px' }}>
                                <div className='modal-content main-card'>
                                    <div className="modal-header">
                                        <h5 className="modal-title">Advance Search</h5>
                                        <button type="button" ref={AdvanceSearchModelcloseButtonRef} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className='row'>

                                            {Array.isArray(advanceSearchingData) ? (
                                                advanceSearchingData?.map((list, index) => (

                                                    <div key={`advancedFilterList${index}`} className='col-md-12 mb-2 d-flex justify-content-between align-items-center'>

                                                        <label className="col-md-4" style={{ textAlign: 'right' }} value={list?.valuePart}>{list?.textPart}</label>
                                                        <input type="text"
                                                            className="ps-1"
                                                            style={{ width: "20px", height: "20px" }}
                                                            placeholder={list?.operator}
                                                            value={list?.operator}
                                                            disabled />

                                                        <div className='col-md-7'>
                                                            {list.dataType === 'string' ?
                                                                <input type="text"
                                                                    className="form-control"
                                                                    ref={ref => (AdvanceSearchModelInputRef.current[index] = ref)}
                                                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                                                    placeholder={list?.textPart}
                                                                    value={list?.Value ? list?.Value : ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const columnName = list?.valuePart;
                                                                        const operator = list?.operator;

                                                                        advanceSearchingData[index] = { ...advanceSearchingData[index], Value: value };
                                                                        setAdvanceSearchingData(advanceSearchingData)

                                                                        const existingIndex = filterData?.AdvanceFilter?.findIndex(item => item.ColumnName === columnName && item.Operator === operator);

                                                                        if (value.trim() === '') {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList.splice(existingIndex, 1);
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            }
                                                                        } else {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList[existingIndex] = { ...updatedAdvList[existingIndex], ColumnValue: value };
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            } else {
                                                                                const newAdvList = [...filterData.AdvanceFilter, { ColumnName: columnName, Operator: operator, ColumnValue: value }];
                                                                                setFilterData({ ...filterData, AdvanceFilter: newAdvList });
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                : <></>}
                                                            {list.dataType === 'bool' ?
                                                                <input
                                                                    className=""
                                                                    type="checkbox"
                                                                    checked={list?.Value ? list?.Value : ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.checked.toString();
                                                                        const columnName = list?.valuePart;
                                                                        const operator = list?.operator;
                                                                        advanceSearchingData[index] = { ...advanceSearchingData[index], Value: value };
                                                                        setAdvanceSearchingData(advanceSearchingData)

                                                                        const existingIndex = filterData?.AdvanceFilter?.findIndex(item => item.ColumnName === columnName && item.Operator === operator);

                                                                        if (value === false) {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList.splice(existingIndex, 1);
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            }
                                                                        } else {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList[existingIndex] = { ...updatedAdvList[existingIndex], ColumnValue: value.toString() };
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            } else {
                                                                                const newAdvList = [...filterData.AdvanceFilter, { ColumnName: columnName, Operator: operator, ColumnValue: value.toString() }];
                                                                                setFilterData({ ...filterData, AdvanceFilter: newAdvList });
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                : <></>}
                                                            {list.dataType === 'datetime' ?
                                                                <DatePicker
                                                                    //  selected={new Date()}
                                                                    selected={list.Value ? new Date(list.Value) : ''}
                                                                    className='form-control input-fields'
                                                                    dateFormat="dd-MMM-yyyy"
                                                                    placeholderText={list.textPart}
                                                                    inputrefs={inputrefs}
                                                                    onChange={(e) => {
                                                                        let dateArr = e?.toString()?.split(' ')
                                                                        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

                                                                        const columnName = list?.valuePart;

                                                                        const operator = list?.operator;

                                                                        advanceSearchingData[index] = { ...advanceSearchingData[index], Value: dateArr };
                                                                        /* console.log(advanceSearchingData[index],"jgs")*/
                                                                        setAdvanceSearchingData(advanceSearchingData)

                                                                        const existingIndex = filterData?.AdvanceFilter?.findIndex(item => item.ColumnName === columnName && item.Operator === operator);

                                                                        if (dateArr === '') {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList.splice(existingIndex, 1);
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            }
                                                                        } else {
                                                                            if (existingIndex !== -1) {
                                                                                const updatedAdvList = [...filterData.AdvanceFilter];
                                                                                updatedAdvList[existingIndex] = { ...updatedAdvList[existingIndex], ColumnValue: dateArr };
                                                                                setFilterData({ ...filterData, AdvanceFilter: updatedAdvList });
                                                                            } else {
                                                                                const newAdvList = [...filterData.AdvanceFilter, { ColumnName: columnName, Operator: operator, ColumnValue: dateArr }];
                                                                                setFilterData({ ...filterData, AdvanceFilter: newAdvList });
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                                : <></>}
                                                        </div>
                                                    </div>
                                                ))

                                            ) : (<></>)}
                                        </div>
                                    </div>
                                    <div className="modal-footer p-0">
                                        <button type="button"
                                            ref={ref => (AdvanceSearchModelInputRef.current['btnAdvSubmit'] = ref)}
                                            className="btn btn-rounded btn-outline-success" onClick={(e) => {
                                                if (AdvanceSearchModelcloseButtonRef.current) {
                                                    AdvanceSearchModelcloseButtonRef.current.click();
                                                }
                                                handleFilter()
                                            }}><span className=" text-success me-2"><i className="fa-solid fa-hand-pointer"></i>
                                            </span>Submit</button>
                                        <button type="button" className="btn btn-rounded btn-outline-danger" onClick={handleResetAdvanceFilter}><span className=" text-danger me-2"><i className="fa-solid fa-refresh"></i>
                                        </span>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <></>}

                    {/* Modal Eye Icon Table Data in Array of Object format*/}

                    <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content" style={{ background: 'var(--background)' }}>
                                <div className="modal-header" style={{ padding: '7px 15px' }}>
                                    <h5 className="modal-title" id="exampleModalLabel">{ModalTitleKey ? ModalTitleKey : 'Show Records'}</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body table-responsive" style={{ maxHeight: '210px', padding: '8px' }}>
                                    <table className="table border text-center">
                                        <thead>
                                            <tr className='light-bg'>
                                                {ModalHeaderKey?.map((th, headIndex) => (
                                                    <>
                                                        <th key={`th${headIndex || 0}`} style={{ padding: '5px 10px', background: 'var(--light-background)' }}>{th}</th>
                                                    </>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ModalData?.map((item, bodyIndex) => (
                                                <tr className="TableTrhover" key={`row${bodyIndex}`} >
                                                    {ModalHeaderKey?.map((key, tdIndex) => (
                                                        <>
                                                            <td key={`key${tdIndex}`}>{item[key]}</td>
                                                        </>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <>
                                    <Dialog
                                        open={showEditTableModal}
                                        onClose={handleCloseEditTableModal}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description"
                                        sx={{
                                            "& .MuiDialog-container": {
                                                "& .MuiPaper-root": {
                                                    width: "100%",
                                                    maxWidth: "900px",
                                                }
                                            },
                                            "& .css-hz1bth-MuiDialog-container": {
                                                alignItems: 'start'
                                            }
                                        }}
                                    >
                                        <DialogTitle id="alert-dialog-title" className='py-1 px-2 border-bottom d-flex justify-content-between'>
                                            <div style={{ fontWeight: 700 }}>Edit Columns</div>
                                            <div style={{ fontWeight: 500, cursor: 'pointer' }} title='close'>
                                                <i className='fa-solid fa-xmark' onClick={handleCloseEditTableModal} />
                                            </div>
                                        </DialogTitle>
                                        <DialogContent className='main-card py-2 m-0' style={{ boxShadow: 'none' }}>
                                            <div className='row'>
                                                <div className='col-6 border-end'>
                                                    <InputBox
                                                        id='Search Header'
                                                        inputrefs={inputrefs}
                                                        placeholder='Search'
                                                        divclassname="col-12 pe-0 mb-1"
                                                        value={searchingEditableHeader}
                                                        onChange={(e) => {
                                                            setSearchingEditableHeader(e.target.value);
                                                        }}
                                                    />
                                                    <div className='col-12' style={{ maxHeight: "70vh", overflowY: 'auto' }}>
                                                        {FinalHeadersValue?.filter(ele => ele.toLowerCase().includes(searchingEditableHeader.toLowerCase())).map((ele, index) => {
                                                            return (
                                                                <div key={index} className='arrow'>
                                                                    <input
                                                                        id={`HeaderEditable_${index}`}
                                                                        disabled={fixedHeader?.includes((ele.replace(" ", "").toLowerCase())) ? true : false} className='me-2'
                                                                        type='checkbox'
                                                                        checked={selectedHeader.some(item => item.headerName === ele)}
                                                                        onChange={(e) => handleCheckBox(ele, e, index)}
                                                                    />
                                                                    <label htmlFor={`HeaderEditable_${index}`}>{ele}</label>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                                <div className='col-6' style={{ maxHeight: "75vh", overflowY: 'auto', fontSize: '12px' }}>
                                                    {selectedHeader && selectedHeader?.map((ele, i) => {
                                                        return (
                                                            <div className='m-1 align-content-center d-flex justify-content-between draggable' key={i}
                                                                onMouseEnter={() => {
                                                                    setHoveredIndex(i);
                                                                }}
                                                                onMouseLeave={() => {
                                                                    setHoveredIndex(null);
                                                                }}
                                                                onDragStart={(e) => handleDragStart(e, i)}
                                                                onDragOver={(e) => e.preventDefault()}
                                                                onDragEnter={(e) => handleDragEnter(e, i)}
                                                                draggable
                                                            >
                                                                <span className='m-0'>
                                                                    <i className="fa-solid fa-grip-vertical me-2" /> {ele.headerName}
                                                                </span>
                                                                <span className='d-flex justify-content-between align-items-center gap-2'>
                                                                    {hoveredIndex === i && <>
                                                                        <Tooltip placement="top" title="Move to Bottom">
                                                                            <label
                                                                                className='form-label arrow text-decoration-underline'
                                                                                onClick={() => handleMoveToBottom(i)} style={{ cursor: 'pointer' }}>
                                                                                <i className="fa-solid fa-down-long"></i>
                                                                            </label>
                                                                        </Tooltip>
                                                                        <Tooltip placement="top" title="Move to Top">
                                                                            <label
                                                                                className='form-label arrow text-decoration-underline'
                                                                                onClick={() => handleMoveToTop(i)} style={{ cursor: 'pointer' }}>
                                                                                <i className="fa-solid fa-up-long" ></i>
                                                                            </label>
                                                                        </Tooltip>
                                                                    </>
                                                                    }
                                                                    {ele.isFixed === false &&
                                                                        <i
                                                                            style={{ cursor: 'pointer' }}
                                                                            title='remove'
                                                                            className='fa fa-close'
                                                                            onClick={() => { handleRemoveShowHeader(ele.headerName) }} />
                                                                    }
                                                                </span>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </DialogContent>
                                        <DialogActions className='main-card py-0 pt-1 my-0 px-1' style={{ boxShadow: 'none' }}>
                                            <div className='d-flex justify-content-between align-items-center py-2 w-100'>
                                                <button type="button" name={'btn1'}
                                                    style={{ fontSize: '13px' }}
                                                    onClick={resetShowHeaderValues}
                                                    className="btn btn-rounded btn-warning">
                                                    <span className="text-white me-1" style={{ fontSize: '12px' }}>
                                                        <i className="fa fa-undo color-warning">
                                                        </i>
                                                    </span>Restore default</button>

                                                <button type="button" name={'btn'}
                                                    style={{ fontSize: '13px' }}
                                                    onClick={handleSaveEditTableData}
                                                    className="btn btn-rounded btn-success">
                                                    <span className="text-white me-2" style={{ fontSize: '12px' }}>
                                                        <i className="fa fa-save color-warning">
                                                        </i>
                                                    </span>Save</button>
                                            </div>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            </div>
                        </div>
                    </div>
                </div>

            ) : (<h5>No Record Found !</h5>)
        }
            {children}
        </div>
    )
}

// Styled Card component with dynamic border color
const StyledCard = styled(Card)(({ theme, borderColor }) => ({
    maxWidth: '100%',
    margin: '14px',
    boxShadow: theme.shadows[3],
    border: `2px solid ${borderColor}`,
    borderRadius: '8px',
}));

export const InvoiceCard = ({ invoice, borderColor, key, currentPageNo, handleChange1, result, handleCheck }) => {

    const OpenImage = (fileBase64, ext) => {
        if (ext === 'pdf') {
            const blob = base64ToBlob(fileBase64, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        } else {
            const blob = base64ToBlob(fileBase64, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    }

    return (
        <>
            <StyledCard borderColor={borderColor} key={key}>
                <CardHeader
                    title={
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                <div className='d-flex align-items-center justify-content-center gap-2'>
                                    {invoice.Checkbox &&
                                        <button className='btn btn-danger btn-sm' onClick={(e) => handleCheck(e.target.checked, invoice.Checkbox, invoice.PolicyNo)}>
                                            <i class="fa-solid fa-square-xmark" title='Reject' style={{ cursor: 'pointer', fontSize: '13px' }} ></i> Cancel
                                        </button>
                                    }
                                    <strong>Invoice No:</strong> <span className="text-success fw-bold">{invoice.InvoiceNo}
                                        &nbsp;{
                                            invoice.InvoiceImage &&
                                                invoice.InvoiceExt === 'pdf' ?
                                                <FaFilePdf title='open PDF'
                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                    onClick={() => { OpenImage(invoice.InvoiceImage, invoice.InvoiceExt) }}
                                                /> : invoice.InvoiceImage &&
                                                <i className="fa fa-image me-2"
                                                    title='show Image'
                                                    onClick={() => { OpenImage(invoice.InvoiceImage, invoice.InvoiceExt) }}
                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                />
                                        }
                                    </span>
                                </div>
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                <strong> Invoice Value: </strong>{invoice.TotalInvoiceValue} {invoice.Currency}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                                <strong>Invoice Date: </strong>{invoice.InvoiceDate}
                            </Typography>
                        </Box>
                    }
                    sx={{ backgroundColor: 'var(--last_bg_all)', color: 'var(--text)', padding: '16px', borderBottom: `1px solid ${borderColor}` }}
                />
                <Divider />
                <CardContent sx={{ padding: '10px' }}>
                    <Grid container spacing={3}>
                        {/* Left Section */}
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                    <strong>Product:</strong>&nbsp;&nbsp; <span className='text-danger fw-bold'>{invoice.Product}</span>
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                    <strong>Category:</strong>&nbsp;&nbsp; {invoice.Category}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaShieldAlt style={{ marginRight: '8px', color: '#607d8b' }} />
                                    <strong>Warranty Period:</strong>&nbsp;&nbsp; {invoice.NoOfYears} {invoice.NoOfYears && "year(s)"}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaTags style={{ marginRight: '8px', color: '#795548' }} />
                                    <strong>Manufacturer:</strong>&nbsp;&nbsp; {invoice.Manufacturer}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                    <strong>Serial No:</strong>&nbsp;&nbsp; {invoice.SerialNo}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaTags style={{ marginRight: '8px', color: '#795548' }} />
                                    <strong>Model No:</strong>&nbsp;&nbsp; {invoice.ModelId}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaMobileAlt style={{ marginRight: '8px', color: '#607d8b' }} />
                                    <strong>IMEI:</strong>&nbsp;&nbsp; {invoice.IMEI}&nbsp; {invoice.ImeiImage &&
                                        <i className="fa fa-image me-2"
                                            title='show Image'
                                            onClick={() => { OpenImage(invoice.ImeiImage, invoice.ImeiExt) }}
                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                        />
                                    }
                                </Typography>
                            </Box>
                        </Grid>
                        {/* Right Section */}
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaUser style={{ marginRight: '8px', color: '#3f51b5' }} />
                                    <strong>Customer:</strong>&nbsp;&nbsp; {invoice.Title} {invoice.FirstName} {invoice.LastName}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaUser style={{ marginRight: '8px', color: '#3f51b5' }} />
                                    <strong>Gender:</strong>&nbsp;&nbsp; {invoice.Gender}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaUser style={{ marginRight: '8px', color: '#3f51b5' }} />
                                    <strong>Telephone Number:</strong>&nbsp;&nbsp; {invoice.TelephoneNumber}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaUser style={{ marginRight: '8px', color: '#3f51b5' }} />
                                    <strong>Email Address:</strong>&nbsp;&nbsp; {invoice.EmailAddress}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaPhone style={{ marginRight: '8px', color: '#4caf50' }} />
                                    <strong>Mobile:</strong>&nbsp;&nbsp; {invoice.MobilePhoneNumber}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaMapMarkerAlt style={{ marginRight: '8px', color: '#f44336' }} />
                                    <strong>Billing Address:</strong>&nbsp;&nbsp; {invoice.BillingAddressLine1}, {invoice.BillingTown}, {invoice.BillingState}, {invoice.BillingPostcode}
                                </Typography>
                            </Box>

                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaStoreAlt style={{ marginRight: '8px', color: '#4caf50' }} />
                                    <strong>Dealer Name:</strong>&nbsp;&nbsp; {invoice.DealerName}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                    <strong>Policy No:</strong>&nbsp;&nbsp; <span className='text-danger fw-bold'>{invoice.PolicyNo}</span>
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                    <strong>Membership Amount:</strong>&nbsp;&nbsp; <span className='text-primary fw-bold'>₹ {invoice.Cost}</span>
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaMoneyBillWave style={{ marginRight: '8px', color: '#00bfa5' }} />
                                    <strong>Payment Status:</strong>&nbsp;&nbsp; {invoice.PaymentStatus === "SUCCESS" ? <span className='text-success fw-bold'>{invoice.PaymentStatus}</span> : <span className='text-danger'>{invoice.PaymentStatus}</span>}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: 1 }}>
                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                    <FaRegCalendarAlt style={{ marginRight: '8px', color: '#ff9800' }} />
                                    <strong>Purchase Date:</strong>&nbsp;&nbsp; {invoice.PurchaseDate}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
        </>
    );
};